import React, { FC, useEffect, useRef, useState, useMemo } from 'react'
import { useHistory, withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'

import {
  AutenticacaoContainer,
  Botao,
  Breadcrumb,
  Carregando,
  ContainerAcoes,
  Cores,
  ErroContainerLayout,
  ErroLayoutContainer,
  FormUnform,
  IconeBack,
  IconeBaixar,
  IconeCerto,
  IconeEditar,
  IconeErrado,
  InputUnform,
  Navegacao,
  SubTitulo,
  TabelaDados,
  TabelaRef,
  TabelaResposta,
  Filtro,
  FormRow,
  SelectUnform,
  Visao
} from 'src/componentes'
import { TipoDeAvaliacao } from 'src/dto'
import { RotasAcademico } from 'src/rotas/academico'
import { RotasProfessor } from 'src/rotas/professor'
import { Api } from 'src/servicos'
import { getApiError } from 'src/servicos/instancias-api'
import { ModalidadeCurso, SituacaoFinanceira } from 'src/tipos'

import {
  AlunosPresencialMock,
  Dados,
  Feedback,
  ModalNotaDisciplina,
  ModalNotaDisciplinaRef,
  ModalNotaModulo,
  NotaDisciplinaProps
} from '..'

import { Container, ContainerLateral, Conteudo } from '../../cadastro/styles'
import { ContainerMain } from '../../styles'
import { ContainerBotao } from '../disciplinas/styles'
import { NotasPresencaProps } from '../disciplinas/tipos'
import { AlunosPresencial } from '../tipos'
import { COLUNAS_DE_NOTAS_E_PRESENCA_NA_TURMA } from './componentes/colunas'
import {
  CabecalhoComEstilos,
  ContainerData,
  ContainerIcone,
  ContainerIcones,
  ContainerLink,
  TabelaComEstilos,
  FormStyled,
  Voltar
} from './styles'
import { opcoesFiltros } from './tipos'

enum Navegacoes {
  Alunos = 'alunos'
}

export const dataFormatadaComBarras = (data = new Date()): string => {
  const novaData = data.toISOString().split('-')

  const dia = novaData[2].slice(0, 2)
  const mes = novaData[1]

  return `${dia}/${mes}`
}

const PaginaVerAlunosPresencial: React.FC<NotasPresencaProps> = ({ match }) => {
  const tabelaRef = useRef<TabelaRef>()
  const modalNotaDisciplinaRef = useRef<ModalNotaDisciplinaRef>(null)
  const modalNotaModuloRef = useRef<ModalNotaDisciplinaRef>(null)

  const history = useHistory()
  const { limparErro, definirErro, erro } = ErroLayoutContainer.useContainer()
  const { visao } = AutenticacaoContainer.useContainer()
  const visaoProfessor = useMemo(() => visao === Visao.Professor, [visao])
  const visaoParceiro = useMemo(() => visao === Visao.Parceiro, [visao])
  const [pronto, definirPronto] = useState<boolean>(false)
  const tipoAvaliacao = AlunosPresencialMock.tipoArquivo
  const [dadosIniciais, definirDadosIniciais] = useState(null)
  const [turma, definirTurma] = useState(null)
  const [modalidade, definirModalidade] = useState(null)
  const [feedback, definirFeedback] = useState<Feedback>(null)
  const [situacaoFiltro, definirSituacaoFiltro] = useState<SituacaoFinanceira>(
    null
  )

  const idDaDisciplina = match.params.idDaDisciplina
  const idTurma = match.params.idDaTurma
  const idDoModulo = match.params.idDoModulo
  const ehPresencial = modalidade === ModalidadeCurso.PosGraduacaoPresencial

  const dadosIniciaisFiltro = useMemo(() => {
    return {
      situacao: visaoProfessor
        ? SituacaoFinanceira[SituacaoFinanceira.Matriculado]
        : null
    }
  }, [visaoProfessor])

  const possuiTurmaPresencialPorDisciplina = () =>
    idTurma !== 'undefined' && idDaDisciplina !== 'undefined'

  const obterTurma = async (): Promise<AlunosPresencial> => {
    return possuiTurmaPresencialPorDisciplina()
      ? await Api.ObterDetalhesDisciplinaPresencial(idDaDisciplina, idTurma)
      : await Api.ObterDetalhesModulo(idTurma, idDoModulo)
  }

  const carregarDisciplina = async () => {
    try {
      definirPronto(false)
      limparErro()

      const modalidade = await Api.RequisitarTurmaPorId(idTurma)
      const turma = await obterTurma()

      if (turma.alunos && turma.alunos.length > 0) {
        definirModalidade(modalidade.modalidadeCurso)
        definirTurma(turma)
        definirDadosIniciais({
          turma: turma.nomeTurma,
          modulo: `${turma.nomeModulo} - ${turma.nomeDisciplina} `,
          professor: turma.tutorTurma
            ? turma.tutorTurma
            : turma.nomeProfessorDisciplina
        })
      } else {
        throw Error('A turma ainda não possui nenhum aluno matriculado.')
      }
    } catch (error) {
      getApiError(error).then(result => {
        const mensagens = result.join('\n')

        definirErro({
          mensagens: `Ops! Houve algum problema no carregamento dos dados.\n${mensagens}`,
          acaoVoltar: () =>
            history.push(
              visaoProfessor ? RotasProfessor.Dashboard : RotasAcademico.Turmas
            )
        })
      })
    } finally {
      definirPronto(true)
    }
  }

  const registrarFeedback = async (dados: Dados) => {
    try {
      const novosDados = { ...dados, avaliacaoId: feedback.avaliacaoId }
      await Api.RegistrarFeedbackProfessor(feedback.salaId, novosDados)
      await carregarDisciplina()
      await tabelaRef.current.CarregarDados(true)
      toast('Feedback salvo com sucesso.', {
        type: 'success'
      })
    } catch (error) {
      toast('Houve um problema ao enviar o feedback', {
        type: 'error'
      })
    }
  }

  const chamarModalPorContextoDeAvaliacao = (dados: NotaDisciplinaProps) => {
    possuiTurmaPresencialPorDisciplina()
      ? modalNotaDisciplinaRef?.current?.abrir(dados)
      : modalNotaModuloRef?.current?.abrir(dados)
  }

  const obterDados = async (): Promise<TabelaResposta | null> => {
    const alunosBase = turma && turma.alunos ? turma.alunos : []
    const dados = !situacaoFiltro
      ? alunosBase
      : alunosBase.filter(aluno => aluno.situacaoFinanceira === situacaoFiltro)

    return { Dados: dados } as TabelaResposta
  }

  // TO-DO: Falta implementação
  // eslint-disable-next-line
  const acaoSucessoFiltro = async dados => {}

  const filtroAlterado = async selecionado => {
    if (!selecionado) {
      await definirSituacaoFiltro(null)
    } else {
      const { id } = selecionado
      await definirSituacaoFiltro(id as SituacaoFinanceira)
    }
    await tabelaRef.current.CarregarDados(true)
  }

  useEffect(() => {
    carregarDisciplina()
  }, [])

  return pronto && !erro ? (
    <Container>
      <ContainerMain>
        <CabecalhoComEstilos>
          <ContainerLink>
            <Voltar
              onClick={() => {
                const rota = `/academico/turmas/notas-presenca/${idTurma}`

                history.push(rota)
              }}
            >
              {IconeBack} Voltar
            </Voltar>
          </ContainerLink>
          <Breadcrumb
            titulo="Cadastro de Notas e Presença na Turma"
            atalhos={[
              {
                texto: 'Acadêmico'
              },
              {
                texto: 'Notas e Presença'
              }
            ]}
          />
        </CabecalhoComEstilos>
        <Conteudo>
          <div id={Navegacoes.Alunos}>
            <SubTitulo texto="Alunos" />
            <FormUnform acaoSucesso={null} dadosIniciais={dadosIniciais}>
              <InputUnform name="turma" label="Turma" disabled={true} />
              <InputUnform
                name="modulo"
                label="Módulo - Disciplina"
                disabled={true}
              />
              <InputUnform
                name="professor"
                label="Professor Responsável"
                disabled={true}
              />
            </FormUnform>
            <>
              <Filtro iniciarAberto={visaoProfessor}>
                <FormStyled
                  acaoSucesso={acaoSucessoFiltro}
                  dadosIniciais={dadosIniciaisFiltro}
                >
                  <FormRow>
                    <SelectUnform
                      className="sm"
                      id="slct_situacao"
                      name="situacao"
                      label="Situação"
                      iconeFechar={true}
                      opcoes={opcoesFiltros}
                      valorAlterado={filtroAlterado}
                    ></SelectUnform>
                  </FormRow>
                </FormStyled>
              </Filtro>
              <TabelaComEstilos
                ref={tabelaRef}
                Colunas={[
                  ...COLUNAS_DE_NOTAS_E_PRESENCA_NA_TURMA,
                  ehPresencial && {
                    Chave: 'encontros',
                    StyleColuna: ehPresencial ? { width: 90 } : { width: 0 },
                    Alinhamento: 'center',
                    Renderizar: (linha: TabelaDados) => (
                      <ContainerIcones>
                        {linha.encontros.map(m =>
                          m.presenca === true ? (
                            <>
                              <ContainerIcone color={Cores.VERDE}>
                                {dataFormatadaComBarras(
                                  new Date(m.dataEncontro)
                                )}
                                {IconeCerto}
                              </ContainerIcone>
                            </>
                          ) : m.presenca === false ? (
                            <>
                              <ContainerIcone color={Cores.PERIGO_ERRO}>
                                {dataFormatadaComBarras(
                                  new Date(m.dataEncontro)
                                )}
                                {IconeErrado}
                              </ContainerIcone>
                            </>
                          ) : (
                            <>
                              <ContainerData>
                                {dataFormatadaComBarras(
                                  new Date(m.dataEncontro)
                                )}
                              </ContainerData>
                            </>
                          )
                        )}
                      </ContainerIcones>
                    ),
                    RenderizarCabecalho: () => (
                      <div style={{ width: 90 }}>Encontros Presenciais</div>
                    )
                  },
                  {
                    Chave: 'acoes',
                    Alinhamento: 'center',
                    Renderizar: (linha: TabelaDados) => (
                      <>
                        {linha.avaliacao.tipoAvaliacao ===
                        TipoDeAvaliacao.AvaliacaoPorAquivo ? (
                          <ContainerAcoes>
                            <button
                              type="button"
                              aria-label="Baixar"
                              title="Baixar"
                              onClick={async e => {
                                e.stopPropagation()
                                await Api.DownloadUltimaAvaliacao(
                                  linha.avaliacao.id
                                )
                              }}
                              disabled={
                                visaoParceiro ||
                                linha.avaliacao.dataUltimaTentativaAvaliacao ===
                                  null
                              }
                            >
                              {IconeBaixar}
                            </button>
                            <button
                              type="button"
                              aria-label="Editar"
                              title="Editar"
                              onClick={() => {
                                const dados = {
                                  avaliacaoId: linha.avaliacao.id,
                                  nome: linha.nomeAluno,
                                  disciplina: turma.nomeDisciplina,
                                  tentativas:
                                    linha.avaliacao.tentativasRestantes,
                                  encontros: linha.encontros,
                                  tipoAvaliacao: tipoAvaliacao,
                                  modalidade: modalidade,
                                  nota: linha.avaliacao.nota,
                                  observacao: linha.avaliacao.observacao,
                                  feedback: linha.avaliacao.feedback
                                }

                                definirFeedback({
                                  avaliacaoId: linha.avaliacao.id,
                                  salaId: linha.idSalaAula
                                })

                                chamarModalPorContextoDeAvaliacao(dados)
                              }}
                            >
                              {IconeEditar}
                            </button>
                          </ContainerAcoes> /* eslint-disable */
                        ) : (
                          <ContainerAcoes>
                            <button
                              type="button"
                              aria-label="Editar"
                              title="Editar"
                              onClick={() => {
                                const dados = {
                                  avaliacaoId: linha.avaliacao.id,
                                  nome: linha.nomeAluno,
                                  disciplina: turma.nomeDisciplina,
                                  tentativas:
                                    linha.avaliacao.tentativasRestantes,
                                  encontros: linha.encontros,
                                  tipoAvaliacao: linha.avaliacao.tipoAvaliacao,
                                  modalidade: modalidade,
                                  modulo: linha.nomeModulo,
                                  nota: linha.avaliacao.nota,
                                  observacao: linha.avaliacao.observacao,
                                  feedback: linha.avaliacao.feedback
                                }

                                definirFeedback({
                                  avaliacaoId: linha.avaliacao.id,
                                  salaId: linha.idSalaAula
                                })

                                chamarModalPorContextoDeAvaliacao(dados)
                              }}
                            >
                              {IconeEditar}
                            </button>
                          </ContainerAcoes>
                        )}
                      </>
                    )
                  }
                ]}
                ObterDados={obterDados}
              />
            </>
          </div>
        </Conteudo>
        <ContainerBotao>
          <Botao
            type="button"
            texto="Voltar"
            tema="Secundario"
            onClick={() =>
              visaoProfessor ? history.push('/professor') : history.goBack()
            }
          />
        </ContainerBotao>
      </ContainerMain>
      <ContainerLateral>
        <Navegacao
          itens={[
            {
              link: Navegacoes.Alunos,
              nome: 'Alunos'
            }
          ]}
        />
      </ContainerLateral>
      <ModalNotaDisciplina
        ref={modalNotaDisciplinaRef}
        backdrop
        id="modal-nota-disciplina"
        acaoPrimaria={registrarFeedback}
      />
      <ModalNotaModulo
        ref={modalNotaModuloRef}
        backdrop
        id="modal-nota-modulo"
        acaoPrimaria={registrarFeedback}
      />
    </Container>
  ) : !pronto && !erro ? (
    <Carregando texto="Carregando dados do aluno..." />
  ) : (
    <ErroContainerLayout />
  )
}

const withContainer: FC<NotasPresencaProps> = (props: NotasPresencaProps) => (
  <ErroLayoutContainer.Provider>
    <PaginaVerAlunosPresencial {...props} />
  </ErroLayoutContainer.Provider>
)

export default withRouter(withContainer)
